import type { MarketId } from '@ps/isp-web-services-types';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';

import { useSportsNextRacesWidget } from '../model';

import { TXTWCL_Each_Way, TXTWCL_N0_odds___N1_places } from './EachWayInfo.messages.json';
import styles from './EachWayInfo.scss';

interface Props {
  marketId: MarketId;
}

const EachWayInfo: React.FC<Props> = ({ marketId }) => {
  const { widgetSelect } = useSportsNextRacesWidget();

  const { placeTerms } = useSelector(
    (state: RootState) => widgetSelect.market(state, marketId) ?? { placeTerms: undefined }
  );

  return (
    <div className={styles.raceInfo}>
      {placeTerms && placeTerms.numPlaces ? (
        <div className={styles.eachWay}>
          <Translation {...TXTWCL_Each_Way} />{' '}
          <Translation
            {...TXTWCL_N0_odds___N1_places}
            values={{
              deductionFraction: placeTerms.deductionFraction,
              numPlaces: placeTerms.numPlaces
            }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default EachWayInfo;
